import { useTranslation } from "react-i18next";
import { Lock, LockOpen, ShieldCheck } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

const TONE = { open: "text-success", closed: "text-destructive", audited: "text-primary" };

export const PeriodRow = ({ period, onStatus }) => {
  const { t } = useTranslation();

  return (
    <NeuCard className="flex flex-wrap items-center gap-3 p-4" data-testid={`period-row-${period.code}`}>
      <span className="font-mono text-sm font-bold" dir="ltr">
        {period.code}
      </span>
      <span className={`text-xs font-bold ${TONE[period.status]}`} data-testid={`period-status-${period.code}`}>
        {t(`acct.periodStatus.${period.status}`)}
      </span>
      <span className="font-mono text-xs text-muted-foreground">
        {t("acct.entries")}: {period.entries}
      </span>
      {period.changed_by ? (
        <span className="text-[11px] text-muted-foreground">
          {period.changed_by} · {(period.changed_at || "").slice(0, 10)}
        </span>
      ) : null}
      <div className="ms-auto flex gap-2">
        {period.status === "open" ? (
          <NeuButton className="px-3 py-2 text-xs" data-testid={`period-close-${period.code}`} onClick={() => onStatus(period, "closed")}>
            <Lock className="h-3.5 w-3.5" /> {t("acct.close")}
          </NeuButton>
        ) : (
          <NeuButton className="px-3 py-2 text-xs" data-testid={`period-reopen-${period.code}`} onClick={() => onStatus(period, "open")}>
            <LockOpen className="h-3.5 w-3.5" /> {t("acct.reopen")}
          </NeuButton>
        )}
        {period.status === "closed" ? (
          <NeuButton className="px-3 py-2 text-xs" data-testid={`period-audit-${period.code}`} onClick={() => onStatus(period, "audited")}>
            <ShieldCheck className="h-3.5 w-3.5" /> {t("acct.audited")}
          </NeuButton>
        ) : null}
      </div>
    </NeuCard>
  );
};
